<style lang="scss" scoped></style>

<template>
  <!-- eslint-disable max-len -->
  <div class="theme-color-wrapper p-2 booking-slots-page">
    <div class="calls row">
      <section class="col-12">
        <h2 cy="page-title" class="font-weight-bolderer mb-2">Add new booking Slot</h2>
        <router-link :to="{ name: 'booking-slots'}" class="body-text">
          &laquo; Go Back to view all booking slots
        </router-link>
      </section>
    </div>

    <div v-if="!loading" class="row my-2">
      <div class="slot-stage-wrapper">
        <div class="col-12">

          <section class="slot-stage">
            <h4 class="pb-1">What time should the slot start?</h4>
            <p>Slots are up to {{ max_slot_length }} minutes long. Calls are terminated when the slot ends</p>

            <div class="clock-custom d-flex" style="font-size: 18pt" cy="start-time">
              <div>
                <i @click="increaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                   class="fas fa-chevron-up d-block"></i>
                <span class="d-block">{{ bookingSlotToCreate.slotBeginHour }} :</span>
                <i @click="decreaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                   class="fas fa-chevron-down d-block"></i>
              </div>

              <div class="ml-1">
                <i @click="increaseTimeSlot('slotBeginMin', mins, updateEndSlot)" class="fas fa-chevron-up d-block"></i>
                <span class="d-block">{{ bookingSlotToCreate.slotBeginMin }}</span>
                <i @click="decreaseTimeSlot('slotBeginMin', mins, updateEndSlot)"
                   class="fas fa-chevron-down d-block"></i>
              </div>
            </div>

            <p class="pb-2 mt-2 font-weight-bolder">
              This slot will start at:
              <b>{{ bookingSlotToCreate.slotBeginHour }}:{{ bookingSlotToCreate.slotBeginMin }}</b>
              <span class="px-1 d-inline-block"
                    v-if="limitedSlot">and end at: <b>{{ bookingSlotToCreate.slotEndHour }}:{{ bookingSlotToCreate.slotEndMin }}</b></span>
            </p>
          </section>

          <section class="slot-stage" v-if="!limitedSlot">
            <h4 class="pb-2">What time should the slot end?</h4>

            <b-alert v-if="!endDateValid" show variant="danger" class="font-weight-bolder p-2">
              <i class="fas fa-exclamation-triangle mr-2"></i>Please ensure the end time is after the start time and within the {{ max_slot_length }} minute duration.
            </b-alert>

            <div class="clock-custom d-flex" style="font-size: 18pt" cy="end-time">
              <div>
                <i @click="increaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                   class="fas fa-chevron-up d-block"></i>
                <span class="d-block">{{ bookingSlotToCreate.slotEndHour }} :</span>
                <i @click="decreaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                   class="fas fa-chevron-down d-block"></i>
              </div>

              <div class="ml-1">
                <i @click="increaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                   class="fas fa-chevron-up d-block"></i>
                <span class="d-block">{{ bookingSlotToCreate.slotEndMin }}</span>
                <i @click="decreaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                   class="fas fa-chevron-down d-block"></i>
              </div>
            </div>

            <p class="pb-2 mt-2 font-weight-bolder" cy="slot-text">
              This slot will start at:
              <b>{{ bookingSlotToCreate.slotBeginHour }}:{{ bookingSlotToCreate.slotBeginMin }}</b>
              <span style="margin-left: 5px" class="d-inline-block">
                and end at: <b>{{ bookingSlotToCreate.slotEndHour }}:{{ bookingSlotToCreate.slotEndMin }}</b></span>
            </p>
          </section>

          <section class="slot-stage">
            <h4 class="pb-2">When should this slot be offered?</h4>
            <p>Choose all the days that apply</p>
            <div>
              <label class="d-block font-weight-bolder" style="font-size: 1rem" v-for="(weekDay, index) in weekDays" :key="index">
                <input :cy="weekDay" v-model="selectedWeekdays" :value="weekDay" type="checkbox" class="mr-1">
                {{ weekDay }}
              </label>
            </div>
          </section>

          <section class="slot-stage">
            <h4 class="pb-2 pt-2">Do you want to apply a date range?</h4>

            <b-form-checkbox @change="resetStartEndDate()" v-model="applyDateRange" name="check-button" switch>
              Apply date range
            </b-form-checkbox>

            <section v-if="applyDateRange">
              <p class="pt-3">Select a start and end date</p>
              <div>
                <label>Start Date</label>
                <b-form-datepicker
                  v-model="bookingSlotToCreate.start_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  @input="bookingSlotToCreate.end_date = ''"
                />
                <label>End Date</label>
                <b-form-datepicker
                  v-model="bookingSlotToCreate.end_date"
                  :min="bookingSlotToCreate.start_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                />
              </div>
            </section>

          </section>

          <section class="slot-stage">
            <button
              :disabled="!validCreate()"
              @click="createBookingSlots()"
              class="btn btn-block btn-success mt-2"
            >
              Add new booking slot (this will make the slot available for bookings)
            </button>
          </section>
        </div>
      </div>
    </div>

    <div class="mt-1" v-else>
      <b-spinner class="d-block" variant="primary"></b-spinner>
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import moment from 'moment';
import BookingSlotService from '@/services/BookingSlotService';
import {ERROR_CODES} from '@/util/errorCodes';
import {mapState} from 'vuex';

export default {
  name: 'create-booking-slot',
  computed: mapState({
    prison: state => state.prison.prison,
    limitedSlot: state => state.prison.prison ? state.prison.prison.limitedSlot : '',
    max_slot_length: state => state.prison.prison ? state.prison.prison.max_slot_length : '',
    allBookingSlots: state => state.bookingSlots.bookingSlots,
  }),
  watch: {
    limitedSlot() {
      this.updateEndSlot();
    }
  },
  data() {
    return {
      bookingSlotToCreate: {
        name: '',
        weekDay: 'Monday',
        slotBeginHour: '09',
        slotBeginMin: '00',
        slotEndHour: '09',
        slotEndMin: '30',
        active: 'active',
        start_date: '',
        end_date: '',
      },
      selectedWeekdays: [],
      weekDays: BookingSlotService.getWeekdays(),
      hours: BookingSlotService.getHours(),
      mins: BookingSlotService.getMinutes(),
      stage: 2,
      slotsToCreate: [],
      endDateValid: true,
      loading: true,
      applyDateRange: false,
    };
  },
  async mounted() {
    await this.$store.dispatch('prison/getPrison');
    this.loading = false;
    if (this.limitedSlot) {
      this.updateEndSlot();
    }
    await this.$store.dispatch('bookingSlots/getBookingSlots');
  },
  methods: {
    setStage(num) {
      this.stage = num;
    },
    validCreate() {
      const valid = this.selectedWeekdays.length > 0 && this.endDateValid;
      const startDate = this.bookingSlotToCreate.start_date.length > 0;

      if (this.applyDateRange) {
        return startDate && valid;
      }
      return valid;
    },
    createBookingSlots() {
      const bc = this.bookingSlotToCreate;
      let duplicateSlots = [];
      let vm = this;

      // Loop through selected days to get duplicated slots and create new ones
      this.selectedWeekdays.forEach((day) => {
        let slotBegin = `${bc.slotBeginHour}:${bc.slotBeginMin}`;
        let slotEnd = `${bc.slotEndHour}:${bc.slotEndMin}`;

        duplicateSlots = duplicateSlots.concat(BookingSlotService.getDuplicatedDates(this.allBookingSlots, day, slotBegin, slotEnd));
        this.slotsToCreate.push(vm.getNewSingleBookingSlot(day)); // add all weekdays
      });
      duplicateSlots = BookingSlotService.filterDuplicatesByDateRange(duplicateSlots, bc);

      // this.manageUpdatingSlots(duplicateSlots[0], duplicateSlots);
      if (duplicateSlots[0]) { // warn if duplicates, otherwise create
        this.displayBookingSlotOverlapModal(duplicateSlots[0], duplicateSlots);
      } else {
        this.createNewSlotsFromWeekdays();
      }
    },
    getNewSingleBookingSlot(weekDay) {
      const start = `${this.bookingSlotToCreate.slotBeginHour}:${this.bookingSlotToCreate.slotBeginMin}`;
      const end = `${this.bookingSlotToCreate.slotEndHour}:${this.bookingSlotToCreate.slotEndMin}`;
      const name = `${weekDay} ${start}-${end} |`;

      return {
        prison_id: this.prison.prison_id,
        name: name.trim(),
        day_of_week: weekDay,
        slot_begin: start,
        slot_end: end,
        active: this.bookingSlotToCreate.active === 'active',
        start_date: this.bookingSlotToCreate.start_date,
        end_date: this.bookingSlotToCreate.end_date,
      };
    },
    createNewSlotsFromWeekdays() {
      let promises = [];
      this.slotsToCreate.forEach((slot) => {
        promises.push(BookingSlotService.createBookingSlot(slot));
      });

      Promise.all(promises).then(() => {
        if (promises.length > 0) {
          this.$toast.success('Booking slots successfully created', {
            toastClassName: ['toast-std', 'success-toast'],
          });
        } else {
          this.$toast.info('No Booking slots created');
        }

        this.$router.push('/booking-slots');
      }).catch(err => {
        console.log('Error creating booking slots', err);
        // eslint-disable-next-line max-len
        if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
          console.log('overlap');
        } else {
          this.$toast.error('Error creating booking slot, all previously created booking slots will remain', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }
      });
    },
    displayBookingSlotOverlapModal(slot, slots) {
      const name = BookingSlotService.getOverlapName(slot);

      this.$swal({
        title: `This overlaps with an existing slot ${name}`,
        text: 'Do you want to overwrite the existing slot?',
        icon: 'warning',
        buttons: true,
      }).then((value) => {
        if (value) { // if yes add new created slot
          // delete overlap
          let slotClone = Object.assign({}, slot);
          slotClone.active = false;
          BookingSlotService.updateBookingSlot(slotClone._id, slotClone).then(() => {
            this.manageUpdatingSlots(slot, slots);
          }).catch(err => {
            console.log('Error deleting booking slot ', err);
            // eslint-disable-next-line max-len
            if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
              this.$toast.error('Error deleting the booking slot, booking slot overlaps', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            } else {
              this.$toast.error('Error deleting the booking slot', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            }
          });
        } else {
          this.removeDayFromSlotsToCreate(slot.day_of_week); // remove slot from booking create
          this.manageUpdatingSlots(slot, slots);
        }
      });
    },
    manageUpdatingSlots(slot, slots) {
      let newSlots = slots.splice(1); // remove the first slot

      if (newSlots[0]) {
        this.displayBookingSlotOverlapModal(newSlots[0], newSlots);
      } else { // finished update all slots
        this.createNewSlotsFromWeekdays();
      }
    },
    removeDayFromSlotsToCreate(day) {
      this.slotsToCreate = this.slotsToCreate.filter((slot) => {
        return slot.day_of_week !== day;
      });
    },
    updateEndSlot() {
      if (this.limitedSlot) { // limited slot, always add 30 mins
        let time = this.bookingSlotToCreate.slotBeginHour + ':' + this.bookingSlotToCreate.slotBeginMin + ':00';
        let addMinutes = moment(time, 'HH:mm:ss').add(this.max_slot_length, 'minutes').format('HH:mm');
        let split = addMinutes.split(':');

        this.bookingSlotToCreate.slotEndHour = split[0];
        this.bookingSlotToCreate.slotEndMin = split[1];
      } else {
        this.checkEndSlotValid();
      }
    },
    checkEndSlotValid() {
      let startTime = this.bookingSlotToCreate.slotBeginHour + ':' + this.bookingSlotToCreate.slotBeginMin + ':00';
      let endTime = this.bookingSlotToCreate.slotEndHour + ':' + this.bookingSlotToCreate.slotEndMin + ':00';

      startTime = moment(startTime, 'HH:mm:ss');
      endTime = moment(endTime, 'HH:mm:ss');

      let duration = moment.duration(endTime.diff(startTime));
      let minutesLeft = duration.asMinutes();

      let negative = Math.sign(minutesLeft) === -1;

      this.endDateValid = !negative && (minutesLeft <= this.max_slot_length);
    },
    increaseTimeSlot(prop, array, callback) {
      let value = this.bookingSlotToCreate[prop];
      let max = array.length - 1;
      let index = array.indexOf(value);

      if (index < max) {
        this.bookingSlotToCreate[prop] = array[index + 1]; // first element
      } else {
        this.bookingSlotToCreate[prop] = array[0];
      }

      if (callback) {
        callback();
      }
    },
    decreaseTimeSlot(prop, array, callback) {
      let value = this.bookingSlotToCreate[prop];
      let max = array.length - 1;
      let index = array.indexOf(value);

      if (index === 0) {
        this.bookingSlotToCreate[prop] = array[max]; // first element
      } else {
        this.bookingSlotToCreate[prop] = array[index - 1];
      }

      if (callback) {
        callback();
      }
    },
    resetStartEndDate() {
      this.start_date = '';
      this.end_date = '';
    }

  },
};
</script>
